import script from "./AllTotal.vue?vue&type=script&setup=true&lang=js"
export * from "./AllTotal.vue?vue&type=script&setup=true&lang=js"

import "./AllTotal.vue?vue&type=style&index=0&id=fbda566e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fbda566e"]])

export default __exports__